import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { People, TaskReadApiClient } from '~/services/Http';

import { TaskStatusEnum } from '../../client.people.generated';

export const GET_EMPLOYEE_ASSIGNED_TASKS_SWR_KEY =
  'TaskReadApiClient.getEmployeeAssignedTasks';

export function useGetEmployeeAssignedTasks(args: {
  employeeId: string;
  lang?: string;
  offset?: number;
  limit?: number;
  order?: People.Order10;
  statuses?: TaskStatusEnum[];
}): UseSWROutput<People.TaskDto[]> {
  return useSWR(
    [
      GET_EMPLOYEE_ASSIGNED_TASKS_SWR_KEY,
      args.employeeId,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.order ?? undefined,
      args?.statuses ?? undefined,
    ],
    ([_, employeeId, lang, offset, limit, order, statuses]) =>
      TaskReadApiClient.getEmployeeAssignedTasks(
        employeeId,
        order,
        offset,
        limit,
        lang,
        statuses,
      ).then((r) => r.data),
  );
}
